export const extractPromptVariables = (text: string) => {
  const regex = /\{\{([^}]+)\}\}/g;
  const matches = [...text.matchAll(regex)];
  const variables = matches.map(match => match[1].trim());
  return [...new Set(variables)];
};
